// frontend/src/components/event/CalendarButton.js
import React, { useState } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import apiService from "../../services/apiService";
import { Calendar, Download, Loader2 } from "lucide-react";

const CalendarButton = ({ eventSlug, className = "" }) => {
  const { t, language } = useLanguage();
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    try {
      const blob = await apiService.getEventCalendar(eventSlug, language);

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${eventSlug}.ics`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading calendar:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleDownload}
      disabled={loading}
      className={`inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 hover:border-gray-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {loading ? (
        <Loader2 className="w-5 h-5 animate-spin" />
      ) : (
        <Calendar className="w-5 h-5" />
      )}
      <span className="font-medium">
        {t({ de: "Zum Kalender hinzufügen", en: "Add to Calendar" })}
      </span>
      <Download className="w-4 h-4" />
    </button>
  );
};

export default CalendarButton;
